import React, { useRef } from "react";
import MolGrid, { Column } from "@moltech/molui/molgrid";
import CardSection from "../../../../../../components/ui/card/CardSection";

const ContractWithoutSchedule = () => {
  const gridRef = useRef();
  return (
    <>
      <CardSection>
        <div className="contract-without-schedule-detail">
          <MolGrid
            ref={gridRef}
            // beforeLoad={beforeMolGridLoad}
            // afterLoad={afterMolGridLoad}
            grouping
            expandableRowGroups={true}
            paginator={false}
            scrollable
            scrollHeight="flex"
            filterDisplay="row"
            sortMode="single"
            showGridlines
            resizableColumns
            // ctxMenuItems={getCtxMenuItems}
            // onRowDoubleClick={handleRowDoubleClick}
          >
            <Column
              field="contractType"
              header="Contract Type"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "10%" }}
              grouping
              sortable
            />
            <Column
              field="contractKey"
              header="Contract Key"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "10%" }}
              grouping
              sortable
            />
            <Column
              field="contract"
              header="Contract"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "25%" }}
              grouping
              sortable
            />
            <Column
              field="client"
              header="Client"
              bodyStyle={{ textAlign: "left" }}
              style={{ width: "20%" }}
              grouping
              sortable
            />
            <Column
              field="department"
              header="Department"
              bodyStyle={{ textAlign: "left" }}
              style={{ width: "10%" }}
              grouping
              sortable
            />
            <Column
              field="cost"
              header="Cost"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "10%" }}
              grouping
              sortable
            />
            <Column
              field="invoiced"
              header="Invoiced"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "8%" }}
              grouping
              sortable
            />
            <Column
              field="balance"
              header="Balance"
              bodyStyle={{ textAlign: "Right" }}
              style={{ width: "7%" }}
              grouping
              sortable
            />
          </MolGrid>
        </div>
      </CardSection>
    </>
  );
};

export default ContractWithoutSchedule;
